import React from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import ProjectsLayout from "./ProjectsLayout";

const SSF = () => {
  return (
    <div>
      <Header />
      <section className="relative py-12 bg-gray-900 sm:py-16 lg:py-20 xl:py-32">
        <div className="absolute inset-0">
          <img
            className="object-cover w-full h-full"
            src="/project-banner2.png"
            alt=""
          />
        </div>

        <div className="absolute inset-0 bg-gray-900/50"></div>

        <div className="relative px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
          <div className="max-w-5xl mx-auto text-center">
            <p className="text-[#23A999] font-medium font-nunito-sans text-xl uppercase">
              Our Project
            </p>
            <h2 className="text-3xl font-bold text-white sm:text-4xl font-nunito-sans lg:text-5xl">
              Stokeford Solar Farm
            </h2>
          </div>
        </div>
      </section>

      <section className="py-12 bg-white sm:py-16 lg:py-20">
        <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-[1450px]">
          <div className="grid grid-cols-1 gap-y-8 lg:grid-cols-7 ">
            <ProjectsLayout />

            <div className=" lg:col-span-4 rounded-xl h-[1400px] pt-0 pb-12 overflow-y-auto [&::-webkit-scrollbar]:hidden">
              <section className="py-12 bg-white sm:py-16 lg:py-2">
                <div className="px-4 mx-auto w-full sm:px-6 lg:px-2">
                  <div className="max-w-3xl mx-auto xl:max-w-4xl">
                    <div className="relative ">
                      <div className="absolute -inset-2">
                        <div className="w-full h-full mx-auto opacity-30 blur-lg filter"></div>
                      </div>

                      <img
                        className="relative rounded-xl"
                        src="/projects2.png"
                        alt=""
                      />
                    </div>
                    <h1 className="text-[38px] font-nunito-sans font-bold text-gray-900 mt-7 sm:text-3xl xl:text-[38px] ">
                      Stokeford Solar Farm
                    </h1>
                    <p className="mt-6 text-[30px] font-bold leading-7 text-black py-2 w-fit rounded-full  font-dm-sans">
                      Dorset, UK
                    </p>
                    <p className="mt-6 text-[18px] font-bold leading-7 text-gray py-2 w-fit rounded-full  font-dm-sans">
                      Comprehensive mechanical and electrical installations,
                      including testing and commissioning.
                    </p>

                    <div className="mt-4">
                      <p className="text-base font-normal leading-7 text-gray-700 font-dm-sans">
                        This is a large-scale solar energy project designed to
                        harness clean energy and contribute to the local power
                        grid. This project involved extensive mechanical and
                        electrical work to ensure efficient and reliable
                        operation
                      </p>
                    </div>
                    <div className="mt-4">
                      <p className="text-base font-normal leading-7 text-gray-700 font-dm-sans">
                        For all the projects, we have provided full electrical
                        installation of the substations and data room which
                        includes all electrical works for the assigned
                        substation areas for the solar fields.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SSF;
